import React from "react";


const Hero = () =>{
    return (
        <>
        <div className="hero-section">
            <h1>Creative Solutions</h1>
            <p className="para">
            A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the charm of existence in this spot, which was created for the bliss of souls like mine
            </p>
        </div>
        </>
    )
}

export default Hero;